// import React from 'react'
// import './feedback.css'
// import { Title } from '../../style/StyleComponent'
// import { Swiper, SwiperSlide } from 'swiper/react'
// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'
// import { Navigation, Pagination } from 'swiper/modules'

// import videoOne from '../../assets/it-tatni-tanishtirish.mp4'
// import videoTwo from '../../assets/it-tatni-tanishtirish.mp4'
// import videoThree from '../../assets/it-tatni-tanishtirish.mp4'
// import videoFour from '../../assets/it-tatni-tanishtirish.mp4'


// const Feedback = () => {
//   const videos = [videoOne, videoTwo, videoThree, videoFour]

//   return (
//     <div className='feedback'>
//       <div className="max-width">
//         <Title>
//           Feedback, o`quvchilar va ota-onalar fikrlari
//         </Title>

//         <Swiper
//           style={{ maxWidth: '1000px', padding: '50px' }}
//           modules={[Navigation, Pagination]}
//           navigation
//           pagination={{ clickable: true }}
//           spaceBetween={20}
//           loop={true}
//           // Responsive sozlamalar:
//           breakpoints={{
//             // 320px dan yuqori ekranlarda (telefon)
//             320: {
//               slidesPerView: 1,
//               slidesPerGroup: 1,
//             },
//             // 768px dan yuqori ekranlarda (planshet/desktop)
//             768: {
//               slidesPerView: 2,
//               slidesPerGroup: 2,
//             } 
//           }}
//         >
//           {videos.map((src, index) => (
//             <SwiperSlide key={index}>
//               <video src={src} controls className="video-slide" style={{ width: '100%', background: 'var(--black)' }}></video>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     </div>
//   )
// }

// export default Feedback

import React from 'react'
import './feedback.css'
import Success from '../success/Success'
import {Title} from '../../style/StyleComponent'

const Feedback = () => {
  return (
    <div className=' max-width feedBack'>
      
        <Title>

        Feedback,o`quvchilar va ota-onalar fikrlari
        </Title>
    
      <Success />
    </div>
  )
}

export default Feedback
